import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import { CenterFlexRow, BackButton } from "../../styles";
import APIManager from "modules/common/apiManager";
import SmppProviderAddEdit from "./SmppProviderAddEdit";
import { MenuItem } from "react-bootstrap";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  FormControl,
  ActionButtons,
  Table,
  DataWithLoader,
  ControlLabel,
  ReportPagination,
  SeachForm,
  DataWrapperClass,
  ButtonCommonTheme,
  Icon,
  SettingDropdownMenu,
} from "modules/theme";
import { modalType } from "../../../../../helpers/dotenv";
import { CustomDropdown } from "../../../../common/components";

class SmppProvider extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `SMPP Provider`;
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    tempList.map((listData) => (listData.selected = e.target.checked));
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
    });
    this.mAPI.sendPostAPI(
      `setting/sms-provider/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        this.setState({ currentPage: 1 });
        this.getSmppServicer(this.state.currentPage, this.state.perPageCount);
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      listData: teamList,
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getSmppServicer(1, "", this.state.search);
      }, 500);
    }
  }

  componentDidMount() {
    this.getSmppServicer(this.state.currentPage, this.state.perPageCount);
  }

  getSmppServicer(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/sms-provider?limit=${perPage}&page_no=${page}&orderBy=create_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });
        if (data && data.data) {
          const newListData = data.data.map((item) => {
            return {
              ...item,
              selected: false,
            };
          });
          that.setState({
            listData: newListData,
            MasterChecked: false,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [], total: 0 });
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      }
    );
  }

  onPaginationChange(page) {
    this.setState({ currentPage: page });
    this.getSmppServicer(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getSmppServicer(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }
  openModalShow(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  closeModal(isUpdated) {
    this.setState({ showHide: false });
    if (isUpdated === true) {
      this.getSmppServicer(this.state.currentPage, this.state.perPageCount);
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, editData: data });
    } else {
      this.setState({ showHide: true, editData: undefined });
    }
  }

  deleteSmsServicer(tSmsServicer) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/sms-provider/${tSmsServicer._id}`,
      undefined,
      (data) => {
        that.setState({ currentPage: 1 });
        that.getSmppServicer(this.state.currentPage, this.state.perPageCount);
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  onChange() {}

  onSingleChange(e, company) {}

  editSmsServicer(tSmsServicer) {
    return (
      <ButtonCommonTheme
        type="edit"
        editOnClick={() => this.openModal(tSmsServicer)}
      />
    );
  }

  getIDDetails(tSmsServicer) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/sms-provider/${tSmsServicer}`,
      (data) => {
        this.setState({ loading: false });
      },
      (error, data) => {}
    );
  }

  renderActions(tSmsServicer, index) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.editSmsServicer(tSmsServicer)}
        <CustomDropdown
          index={index}
          totalLength={this.state.listData.length || 0}
        >
          <MenuItem style={{ marginLeft: "0px" }}>
            <a
              onClick={(e) =>
                confirm().then((e) => {
                  this.deleteSmsServicer(tSmsServicer, e);
                })
              }
            >
              Delete
            </a>
          </MenuItem>
        </CustomDropdown>
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    return formData;
  }

  renderActionBar() {
    const ImportTrigger = ({ onClick }) => {
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <ModalTrigger
        title="SMPP Provider"
        trigger={<ImportTrigger />}
        size="md"
        showHide={this.state.showHide}
        closeModal={this.closeModal}
        openModal={this.openModal}
        openModalShow={this.openModalShow}
        dialogClassName={this.state.modalType}
      >
        <SmppProviderAddEdit
          update={() => this.setState({ currentPage: 1 })}
          size="small"
          isEdit={false}
          editData={this.state.editData}
          infoData={this.state.infoData}
          closeModal={this.closeModal}
          modalType={this.state.modalType}
        />
      </ModalTrigger>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Message Setting"), link: "/message" },
      { title: __("SMPP Provider"), link: "/settings/SMPP-Provider" },
    ];

    const mainContent = (
      <DataWrapperClass className="tableFixHeadSecondary">
        <Table whiteSpace="nowrap" bordered hover>
          <thead>
            <tr>
              <th onClick={this.onClick}>
                <FormControl
                  componentClass="checkbox"
                  checked={this.state.MasterChecked}
                  onChange={(e) => this.onMasterCheck(e)}
                />
              </th>
              <th>{__("name")}</th>
              <th>{__("host")}</th>
              <th>{__("port")}</th>
              <th>{__("system Id")}</th>
              <th>{__("SSL/TLS")}</th>
              <th>{__("Actions")}</th>
            </tr>
          </thead>
          <tbody id="SmppProvider">
            {this.state.listData &&
              this.state.listData.map((tSmsServicer, index) => (
                <tr key={tSmsServicer._id}>
                  <td onClick={this.onClick}>
                    <FormControl
                      componentClass="checkbox"
                      checked={tSmsServicer.selected}
                      onChange={(e) => this.onItemCheck(e, tSmsServicer)}
                    />
                  </td>
                  <td>{tSmsServicer.name}</td>
                  <td>{tSmsServicer.host}</td>
                  <td>{tSmsServicer.port}</td>
                  <td>{tSmsServicer.systemId}</td>
                  <td>{tSmsServicer.secure ? "ssl" : "tls"}</td>
                  <td>{this.renderActions(tSmsServicer, index)}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`SMPP Provider`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-5">
                      <FormControl
                        type="text"
                        placeholder={"Search Here"}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span className="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 && (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    )}
                  </div>
                }
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText="Sorry..! No SMPP Provider Found"
                  emptyImage="/images/emptyimg.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

SmppProvider.contextTypes = {
  __: PropTypes.func,
};

export default SmppProvider;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmppProvider/components/SmppProvider.js